import { quizState } from "./quizState"
import { rerender } from "./render"

// ============================================================
// VERIFY SCREEN NAVIGATION
// The verify screen is a single scrollable surface. There is no
// detail view, filters, or queue. State lives entirely in the DOM
// `.active` class on `#verify`, mirroring the existing pattern for
// the quiz and results screens. `backHome` in `quizState.ts` clears
// the same class when navigating away.
// ============================================================

export function openVerify() {
  const home = document.getElementById("home")
  if (home) home.style.display = "none"
  quizState.screen = null
  document.getElementById("verify")?.classList.add("active")
  window.scrollTo({ top: 0, behavior: "smooth" })
  rerender()
}
